import { fetchApi } from '@/config/axiosSetting.ts';
import { InsurancesQueryResponseType } from '@/common/queries/selections/insurances/insurancesQuery.type.ts';

export const insurancesQueryFunction = (): Promise<
  InsurancesQueryResponseType[]
> => fetchApi.get('/selection_item/insurance/wop_list/');
